import { useEffect } from 'react';

export const FRESH_CHAT_EVENT = 'clu:fresh-chat';

/**
 * New chat landed (even on an already empty chat): the composer takes the
 * caret and Clu waves. Sent a beat later so a session mounting for it hears it.
 */
export function announceFreshChat() {
  window.setTimeout(() => {
    window.dispatchEvent(new Event(FRESH_CHAT_EVENT));
  }, 50);
}

export function useFreshChat(onFresh: () => void) {
  useEffect(() => {
    window.addEventListener(FRESH_CHAT_EVENT, onFresh);
    return () => window.removeEventListener(FRESH_CHAT_EVENT, onFresh);
  }, [onFresh]);
}
